/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */

'use strict';

import * as tools from '../utils/tools';
import { ClientProperties } from '../entities/entitybase';
import * as types from '../utils/dvtypes';

class ExtensionCache {
    constructor() {
        this.allExpressions = new tools.Dictionary();
        this.allActions = new tools.Dictionary();
        this.allWidgets = new tools.Dictionary();
        this.allAdapters = new tools.Dictionary();
        this.allCustomEndpoints = new tools.Dictionary();

        this.registeredExpressions = new tools.Dictionary();
        this.registeredActions = new tools.Dictionary();
        this.registeredWidgets = new tools.Dictionary();
        this.registeredAdapters = new tools.Dictionary();
        this.registeredCustomEndpoints = new tools.Dictionary();
    }

    /**
     * Register an expression extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} expression
     */
    registerExpression (expression) {
        return registerExpression(expression);
    }

    /**
     * Register an action extension entity
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} action
     */
    registerAction (action) {
        return registerAction(action);
    }

    /**
     * Register a widget extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} widget
     */
    registerWidget (widget) {
        return registerWidget(widget);
    }

    /**
     * Register an adapter extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} adapter
     */
    registerAdapter (adapter) {
        return registerAdapter(adapter);
    }

    // We are not going to register the endpoint here so that designers are not confused since endpoint entities will not be pulled down by non-designers.
    // /**
    //  * Register an endpoint extension entity.
    //  * Instance entry point to library function to support non-ES6 access.
    //  * @param {EntityBase} endpoint
    //  */
    // registerEndpoint (endpoint) {
    //     return registerEndpoint(endpoint);
    // }
    //
    // /**
    //  * Unregister an endpoint extension entity.
    //  * Instance entry point to library function to support non-ES6 access.
    //  * @param {EntityBase} endpoint
    //  */
    // unregisterEndpoint (endpoint) {
    //     return unregisterEndpoint(endpoint);
    // }

    /**
     * Apply client properties for an expression type extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} entity
     */
    applyExpressionClientProperties (entity) {
        return applyExpressionClientProperties(entity);
    }

    /**
     * Apply client properties for an action type extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} entity
     */
    applyActionClientProperties (entity) {
        return applyActionClientProperties(entity);
    }

    /**
     * Apply client properties for a widget type extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} entity
     */
    applyWidgetClientProperties (entity) {
        return applyWidgetClientProperties(entity);
    }

    /**
     * Apply client properties for an adapter type extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} entity
     */
    applyAdapterClientProperties (entity) {
        return applyAdapterClientProperties(entity);
    }

    /**
     * Apply client properties for an endpoint type extension entity.
     * Instance entry point to library function to support non-ES6 access.
     * @param {EntityBase} entity
     */
    applyEndpointClientProperties (entity) {
        return applyEndpointClientProperties(entity);
    }
}

export const extensionCache = new ExtensionCache();

/**
 * Register an expression extension entity.
 * @param {EntityBase} expression
 */
export function registerExpression (expression) {
    app.dv.helpers.exprEng.register(expression.Definition);
    app.dv.cache.extensions.registeredExpressions.add(expression.ExtensionID, expression, expression.UID);
}

/**
 * Register an action extension entity
 * @param {EntityBase} action
 */
export function registerAction (action) {
    app.dv.actionLibrary.register(action);
    //Here we need to key by UID to prevent collisions with dvCore actions in the event that the ExtensionID is < 49...KB
    app.dv.cache.extensions.registeredActions.add(action.UID, action, action.UID);
}

/**
 * Register a widget extension entity.
 * @param {EntityBase} widget
 */
export function registerWidget (widget) {
    app.dv.widgets.register(widget);
    app.dv.cache.extensions.registeredWidgets.add(widget.UID, widget, widget.UID);
}

/**
 * Register an adapter extension entity.
 * @param {EntityBase} adapter
 */
export function registerAdapter (adapter) {
    app.dv.cache.extensions.registeredAdapters.add(adapter.UID, adapter, adapter.UID);
}

// We are not going to register the endpoint here so that designers are not confused since endpoint entities will not be pulled down by non-designers.
// /**
//  * Register an endpoint extension entity.
//  * @param {EntityBase} endpoint
//  */
// export async function registerEndpoint (endpoint) {
//     if (endpoint._State === app.dv.types.EntityStates.Deleted) {
//         // cannot register a deleted endpoint entity.
//         return false;
//     }
//
//     let success = true;
//     if (!endpoint.Definition.IsPublished) {
//         // If this service is not published, we must publish it before we can register it.
//         endpoint.Definition.IsPublished = true;
//         let clone = tools.deepClone(endpoint, "clientProperties");
//         clone.clientProperties = endpoint.clientProperties;
//         clone._State = types.EntityStates.Modified;
//         success = await app.dv.designer.saveEntityToServer(clone, "ExtensionID", app.dv.services.endpoints.saveExtensions, extensionCache.allCustomEndpoints);
//     }
//
//     // ensure that the entity is saved (with this published flag).
//     if (success) {
//         app.dv.cache.extensions.registeredCustomEndpoints.add(endpoint.ExtensionID, endpoint, endpoint.UID);
//         app.dv.services.endpoints.register(endpoint.Definition.ServiceName, endpoint.Definition.EndpointName, endpoint.Definition.IsAuthRequired);
//     }
//
//     return success;
// }
//
// /**
//  * Register an endpoint extension entity.
//  * @param {EntityBase} endpoint
//  */
// export async function unregisterEndpoint (endpoint) {
//     let success = true;
//     if (endpoint.Definition.IsPublished && endpoint._State !== app.dv.types.EntityStates.Deleted) {
//         // If this service is published, we must unpublish it before we can register it.
//         endpoint.Definition.IsPublished = false;
//         let clone = tools.deepClone(endpoint, "clientProperties");
//         clone.clientProperties = endpoint.clientProperties;
//         clone._State = types.EntityStates.Modified;
//         success = await app.dv.designer.saveEntityToServer(clone, "ExtensionID", app.dv.services.endpoints.saveExtensions, extensionCache.allCustomEndpoints);
//     }
//
//     if (success) {
//         app.dv.cache.extensions.registeredCustomEndpoints.remove(endpoint.ExtensionID);
//         app.dv.services.endpoints.unregister(endpoint.Definition.ServiceName, endpoint.Definition.EndpointName);
//     }
// }

/**
 * Apply client properties for an expression type extension entity.
 * @param {EntityBase} entity
 */
export function applyExpressionClientProperties (entity) {
    if (entity == null) {
        return;
    }
    entity.clientProperties = new ClientProperties(types.EntityTypes.Expression);
}

/**
 * Apply client properties for an action type extension entity.
 * @param {EntityBase} entity
 */
export function applyActionClientProperties (entity) {
    if (entity == null) {
        return;
    }
    entity.clientProperties = new ClientProperties(types.EntityTypes.Action);
    entity.Scope = entity.Definition.Metadata.Scope;
}

/**
 * Apply client properties for a widget type extension entity.
 * @param {EntityBase} entity
 */
export function applyWidgetClientProperties (entity) {
    if (entity == null) {
        return;
    }
    entity.clientProperties = new ClientProperties(types.EntityTypes.Widget);
    entity.Scope = entity.Definition.Metadata.Scope;
}

/**
 * Apply client properties for an adapter type extension entity.
 * @param {EntityBase} entity
 */
export function applyAdapterClientProperties (entity) {
    if (entity == null) {
        return;
    }
    entity.clientProperties = new ClientProperties(types.EntityTypes.Adapter);
    entity.Scope = entity.Definition.Metadata.Scope;
}

/**
 * Apply client properties for an endpoint type extension entity.
 * @param {EntityBase} entity
 */
export function applyEndpointClientProperties (entity) {
    if (entity == null) {
        return;
    }
    if (entity.clientProperties == null) {
        entity.clientProperties = new ClientProperties(types.EntityTypes.Endpoint);
    }
}
